import { render, staticRenderFns } from "./BuyPanel.vue?vue&type=template&id=e9535cc4"
import script from "./BuyPanel.vue?vue&type=script&lang=js"
export * from "./BuyPanel.vue?vue&type=script&lang=js"
import style0 from "./BuyPanel.vue?vue&type=style&index=0&id=e9535cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports